import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'hooks/useTranslation';

const ProfilePackageInfo = ({
  packageType,
  remainingConversations,
  remainingDays,
}) => {
  const { getTranslation, getAppLocale } = useTranslation('COMMON');
  const { t } = getTranslation();
  const locale = getAppLocale();

  return (
    <div className='primary__menu__bottom__profile__menu__inner__seperator primary__menu__bottom__profile__menu__inner__package'>
      <div className='primary__menu__bottom__profile__menu__inner__package__name'>
        {t('PACK_TYPE')}: &nbsp;{' '}
        <span className='primary__menu__bottom__profile__menu__inner__package__name__type'>
          {packageType}
        </span>
      </div>
      <div className='primary__menu__bottom__profile__menu__inner__package__remainconv'>
        <p>
          {t('REMAINING_CONVS')}: &nbsp;{' '}
          <span className='count'>{remainingConversations[locale]}</span>
        </p>
      </div>
      <div className='primary__menu__bottom__profile__menu__inner__package__remaintime'>
        {t('REMAINING_DAYS')}: &nbsp;{' '}
        <span className='day'>{remainingDays[locale]}</span>
      </div>
    </div>
  );
};

ProfilePackageInfo.propTypes = {
  packageType: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  remainingConversations: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  remainingDays: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ProfilePackageInfo;
